import i18n from "../lib/i18n";
import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Modal from "./Modal";

import { CompleteActionSchema } from "../lib/schemas";
import { currency } from "../lib/helpers";
import { budgetDisplayName } from "@react/views/budgets/shared/components/budget_form/helpers/budget_display_name.helper";
import { Notification } from "@puts/notification.component";

const completedYearMin = CompleteActionSchema.fields.completed_year
  .describe()
  .tests.find((test) => test.name === "min").params.min;

const CompleteActionModal = (props) => {
  const { action } = props;

  const handleSubmit = (values, actions) => {
    const data = {
      id: action.id,
      year: action.year,
      ...values,
    };

    props.completeAction(data, () => {
      actions.setSubmitting(false);
    });
  };

  return (
    <Formik
      initialValues={{
        completed_year: "",
        final_cost: "",
        comment: "",
      }}
      validationSchema={CompleteActionSchema}
      onSubmit={handleSubmit}
      render={(formProps) => (
        <Form role="form">
          <Modal
            title={i18n.t(
              "js.components.complete_action_modal.complete_action"
            )}
            buttons={
              <button
                type="submit"
                className="btn btn-primary"
                disabled={formProps.isSubmitting || !formProps.isValid}
              >
                {i18n.t("js.components.complete_action_modal.complete_action")}
              </button>
            }
            onClose={props.hideModal}
            includeDialog={props.includeDialog}
          >
            <div className="alert alert-info">
              {i18n.t("js.components.complete_action_modal.info")}
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group required">
                  <label>
                    {i18n.t(
                      "js.components.complete_action_modal.completed_year"
                    )}
                  </label>
                  <br />
                  <div className="input-group" style={{ width: 150 }}>
                    <span className="input-group-addon">
                      {i18n.t("js.helpers.year")}
                    </span>
                    <Field
                      type="number"
                      className="form-control"
                      name="completed_year"
                    />
                  </div>
                  <ErrorMessage
                    component={ErrorDisplay}
                    name="completed_year"
                  />

                  <p className="help-block">
                    {i18n.t("js.components.complete_action_modal.current_year")}{" "}
                    <SuggestedValueLink
                      formProps={formProps}
                      name="completed_year"
                      value={new Date().getFullYear()}
                    />
                    {action.year !== new Date().getFullYear() &&
                      action.year <= new Date().getFullYear() + 1 && (
                        <>
                          <br />
                          {i18n.t(
                            "js.components.complete_action_modal.planned_year"
                          )}{" "}
                          <SuggestedValueLink
                            formProps={formProps}
                            name="completed_year"
                            value={action.year}
                          />
                        </>
                      )}
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    {i18n.t("js.components.complete_action_modal.final_cost")}
                  </label>
                  <br />
                  <div className="input-group" style={{ width: 200 }}>
                    <Field
                      className="form-control"
                      name="final_cost"
                      type="number"
                    />
                    <span className="input-group-addon">
                      {i18n.t("js.helpers.currency")}
                    </span>
                  </div>
                  <ErrorMessage component={ErrorDisplay} name="final_cost" />
                  <p className="help-block">
                    {i18n.t("js.components.complete_action_modal.planned_cost")}{" "}
                    <SuggestedValueLink
                      formProps={formProps}
                      name="final_cost"
                      value={Math.round(action.total_price)}
                      label={currency(action.total_price)}
                    />{" "}
                    {i18n.t(
                      "js.components.complete_action_modal.excluding_vat"
                    )}
                  </p>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label>
                {i18n.t("js.components.complete_action_modal.comment")}
              </label>
              <br />
              <Field
                name="comment"
                component="textarea"
                className="form-control"
              />
              <ErrorMessage component={ErrorDisplay} name="comment" />
              <p className="help-block">
                {i18n.t("js.components.complete_action_modal.comment_info")}
              </p>
            </div>

            {budgetMovedNotice(
              action,
              formProps.values.completed_year,
              completedYearMin
            )}
          </Modal>
        </Form>
      )}
    />
  );
};

const budgetMovedNotice = (action, completedYear, minYear) => {
  if (
    action.budget_name == null ||
    completedYear === "" ||
    completedYear < minYear ||
    Number(completedYear) === action.year
  ) {
    return null;
  }

  return (
    <Notification variant="yellow">
      {i18n.t("js.components.complete_action_modal.budget_moved_notice", {
        year: completedYear,
        budget_name: budgetDisplayName({
          name: action.budget_name,
          year: action.year,
        }),
      })}
    </Notification>
  );
};

const SuggestedValueLink = ({ formProps, name, value, label = undefined }) => (
  <a
    href="#"
    onClick={(event) => {
      event.preventDefault();
      formProps.setFieldValue(name, value);
    }}
  >
    {label || value}
  </a>
);

const ErrorDisplay = (props) => (
  <div style={{ marginTop: "5px", marginLeft: "5px", color: "#900" }}>
    {props.children}
  </div>
);

export default CompleteActionModal;
